/* RESET24 — extra interactions: reveal, hero, PDP gallery, variant picker, sticky ATC. */
(function () {
  'use strict';
  var root = document.documentElement;
  root.classList.add('r24-js');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function track(e, d) { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: e }, d || {})); }

  function reveal() {
    var els = [].slice.call(document.querySelectorAll('.r24-reveal:not(.is-in)'));
    if (!('IntersectionObserver' in window) || reduce || (window.Shopify && Shopify.designMode)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { threshold: .12 });
    els.forEach(function (e) { io.observe(e); });
  }

  function hero() {
    document.querySelectorAll('[data-r24-hero]:not([data-bound])').forEach(function (h) {
      h.setAttribute('data-bound', '1');
      h.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse' || window.innerWidth < 900) return;
        var r = h.getBoundingClientRect(), x = (e.clientX - r.left) / r.width;
        h.setAttribute('data-active', x < .5 ? 'day' : 'night');
      });
      h.querySelectorAll('[data-hero-panel]').forEach(function (p) {
        p.addEventListener('click', function () { h.setAttribute('data-active', p.getAttribute('data-hero-panel')); });
      });
    });
  }

  function gallery() {
    document.querySelectorAll('[data-r24-gallery]:not([data-bound])').forEach(function (g) {
      g.setAttribute('data-bound', '1');
      var slides = [].slice.call(g.querySelectorAll('[data-slide]'));
      var thumbs = [].slice.call(g.querySelectorAll('[data-thumb]'));
      var cur = 0;
      function go(i) {
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.hidden = k !== cur; });
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      }
      g.r24go = function (mediaId) {
        slides.forEach(function (s, k) { if (String(s.getAttribute('data-slide')) === String(mediaId)) go(k); });
      };
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var p = g.querySelector('[data-prev]'), n = g.querySelector('[data-next]');
      if (p) p.addEventListener('click', function () { go(cur - 1); });
      if (n) n.addEventListener('click', function () { go(cur + 1); });
      go(0);
    });
  }

  function pdp() {
    document.querySelectorAll('[data-r24-pdp]:not([data-bound])').forEach(function (sec) {
      sec.setAttribute('data-bound', '1');
      var form = sec.querySelector('form');
      var data = sec.querySelector('[data-variants]');
      if (!form || !data) return;
      var variants = JSON.parse(data.textContent);
      var idInput = form.querySelector('input[name="id"]');
      var btn = form.querySelector('[data-atc]');
      var sticky = sec.querySelector('[data-sticky]');
      var priceEls = sec.querySelectorAll('[data-price]');
      var gal = sec.querySelector('[data-r24-gallery]');
      var labels = { add: btn ? btn.getAttribute('data-label-add') : '', out: btn ? btn.getAttribute('data-label-out') : '' };
      function selected() {
        var o = [];
        form.querySelectorAll('input[type="radio"]:checked').forEach(function (r) { o[+r.getAttribute('data-option-index')] = r.value; });
        return o;
      }
      function update() {
        var o = selected();
        var v = variants.filter(function (x) { return x.options.join('|') === o.join('|'); })[0];
        if (!v) { if (btn) { btn.disabled = true; btn.querySelector('span').textContent = labels.out; } return; }
        idInput.value = v.id;
        var html = '<span class="r24-price__now">' + v.price + '</span>' + (v.compare ? ' <s>' + v.compare + '</s> <span class="r24-save">' + v.save + '</span>' : '');
        priceEls.forEach(function (p) { p.innerHTML = html; });
        document.querySelectorAll('[data-btn-label]').forEach(function (b) { b.textContent = v.available ? labels.add : labels.out; });
        document.querySelectorAll('[data-atc], [data-atc-sticky]').forEach(function (b) { b.disabled = !v.available; });
        if (v.media && gal && gal.r24go) gal.r24go(v.media);
        if (history.replaceState) history.replaceState(null, '', '?variant=' + v.id);
      }
      form.addEventListener('change', function (e) {
        if (e.target.name && e.target.name.indexOf('options[') === 0) {
          var sel = e.target.getAttribute('data-opt-name');
          track('height_select', { option: sel, value: e.target.value });
          update();
        }
      });
      form.addEventListener('submit', function () { track('add_to_cart', { variant: idInput.value }); });

      if (sticky && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(btn);
      }
      track('view_item');
    });
  }

  function init() { reveal(); hero(); gallery(); pdp(); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
